document.documentElement.classList.remove('no-js');

const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

async function getCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
  return response.json();
}

function cartItemMarkup(item) {
  const image = item.image ? `<img src="${item.image}" alt="">` : '';
  const options = item.options_with_values?.filter((option) => option.value !== 'Default Title').map((option) => `${option.name}: ${option.value}`).join('<br>') || '';
  return `<article class="hv-cart-item" data-key="${item.key}">${image}<div><h3>${item.product_title}</h3><small>${options}</small><div class="hv-cart-qty"><button type="button" data-cart-change="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease">-</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Increase">+</button></div></div><strong>${money(item.final_line_price)}</strong></article>`;
}

async function renderCart(open = false) {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const cart = await getCart();
  document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
  const items = drawer.querySelector('[data-cart-items]');
  items.innerHTML = cart.item_count ? cart.items.map(cartItemMarkup).join('') : '<div class="hv-empty"><h2>Your cart is empty</h2><a class="hv-btn" href="/products/high-protein-meal-replacement">Shop now</a></div>';
  drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  drawer.querySelector('[data-checkout-button]').disabled = !cart.item_count;
  if (open) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
}

function closeCart() {
  const drawer = document.querySelector('[data-cart-drawer]');
  drawer?.classList.remove('is-open');
  drawer?.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
}

function setMobileMenu(menu, panel, open) {
  if (!menu || !panel) return;
  menu.setAttribute('aria-expanded', String(open));
  panel.hidden = !open;
  panel.classList.toggle('is-open', open);
}

function closeMobileMenus() {
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const panel = menu.closest('.hv-header')?.querySelector('[data-mobile-panel]');
    setMobileMenu(menu, panel, false);
  });
}

closeMobileMenus();
document.addEventListener('DOMContentLoaded', closeMobileMenus);
document.addEventListener('shopify:section:load', closeMobileMenus);
window.addEventListener('resize', () => {
  if (window.innerWidth > 900) closeMobileMenus();
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMobileMenus();
});

document.addEventListener('click', async (event) => {
  const cartOpen = event.target.closest('[data-cart-open]');
  if (cartOpen) { event.preventDefault(); await renderCart(true); return; }
  if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
  const change = event.target.closest('[data-cart-change]');
  if (change) {
    change.disabled = true;
    await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }) });
    await renderCart(true);
    return;
  }
  const variant = event.target.closest('[data-variant-id]');
  if (variant) {
    const scope = variant.closest('[data-product-scope]');
    scope.querySelectorAll('[data-variant-id]').forEach((button) => button.classList.toggle('is-active', button === variant));
    scope.querySelector('[name="id"]').value = variant.dataset.variantId;
    scope.querySelector('[data-selected-variant]').textContent = variant.dataset.variantTitle;
    const imageId = variant.dataset.imageId;
    if (imageId) scope.querySelector(`[data-gallery-image-id="${imageId}"]`)?.click();
    return;
  }
  const bundle = event.target.closest('[data-bundle-qty]');
  if (bundle) {
    const scope = bundle.closest('[data-product-scope]');
    scope.querySelectorAll('[data-bundle-qty]').forEach((card) => card.classList.toggle('is-active', card === bundle));
    bundle.querySelector('input').checked = true;
    scope.querySelector('[name="quantity"]').value = bundle.dataset.bundleQty;
    return;
  }
  const thumb = event.target.closest('[data-gallery-image]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const mainImage = gallery.querySelector('[data-gallery-main]');
    mainImage.removeAttribute('srcset');
    mainImage.src = thumb.dataset.galleryImage;
    gallery.querySelectorAll('[data-gallery-image]').forEach((button) => button.classList.toggle('is-active', button === thumb));
    return;
  }
  const galleryAction = event.target.closest('[data-gallery-action]');
  if (galleryAction) {
    const gallery = galleryAction.closest('[data-gallery]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-image]')];
    const activeIndex = Math.max(0, thumbs.findIndex((button) => button.classList.contains('is-active')));
    const offset = galleryAction.dataset.galleryAction === 'next' ? 1 : -1;
    thumbs[(activeIndex + offset + thumbs.length) % thumbs.length]?.click();
    return;
  }
  const carousel = event.target.closest('[data-carousel-action]');
  if (carousel) {
    const track = carousel.closest('[data-carousel]').querySelector('[data-carousel-track]');
    track.scrollBy({ left: track.clientWidth * (carousel.dataset.carouselAction === 'next' ? 1 : -1), behavior: 'smooth' });
    return;
  }
  const menu = event.target.closest('[data-mobile-menu]');
  if (menu) {
    const panel = menu.closest('.hv-header')?.querySelector('[data-mobile-panel]');
    setMobileMenu(menu, panel, panel?.hidden ?? true);
    return;
  }
  if (event.target.closest('[data-mobile-panel] a') || !event.target.closest('.hv-header')) closeMobileMenus();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';
  try {
    const data = new FormData(form);
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    if (!response.ok) throw new Error(await response.text());
    await renderCart(true);
  } catch (error) {
    alert('Unable to add this item. Please try again.');
    console.error(error);
  } finally {
    button.disabled = false;
    button.textContent = original;
  }
});

const videos = document.querySelectorAll('video[autoplay]');
const videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting ? entry.target.play().catch(() => {}) : entry.target.pause()), { threshold: .2 });
videos.forEach((video) => videoObserver.observe(video));

const primaryForm = document.querySelector('[data-product-form]');
const sticky = document.querySelector('[data-sticky-buy]');
if (primaryForm && sticky) {
  new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .1 }).observe(primaryForm);
  sticky.querySelector('button')?.addEventListener('click', () => primaryForm.requestSubmit());
}

renderCart(false).catch(() => {});
